import { Point } from '../contract/map'

// 默认定位
export const DEFAULT_POSITION: Point = {
  lat: 31.230525,
  lng: 121.473667,
}
